import PackageCollection from '../../collections/common/packageCollection';
import packageSearchTemplate from '../templates/packageSearch.hbs';
import packageSearchResultTemplate from '../templates/packageSearchResult.hbs';
import $ from 'jquery';
import _ from 'lodash';
import Moment from 'moment';

$.valHooks.sdaPackageSearch = {
    get(el) {
        return $(el).data('sdaPackageSearchValue');
    },
    set(el, val) {
        $(el)
            .data('sdaPackageSearchValue', val) // sets the local value
            .trigger('change.sdaPackageSearch', val) // emits the event for outside listeners
            .trigger('setVal.sdaPackageSearch', val);

        return $(el);
    },
};

export default class PackageSearch {
    constructor(el, opts) {
        this.el = el;
        this.$el = $(el);
        this.opts = {
            placeholder: 'search stories',
            filtertypes: opts.filtertypes || ['STORY', 'GALLERY'],
            onChange: null,
            ...opts,
        };
        this.lastQuantity = 0;
        this.lastResult = null;
        this.searchObject = new PackageCollection();
        this.el.type = 'sdaPackageSearch';
        this.$el.addClass('sda-package-search');
        this.$el.html(packageSearchTemplate(this.opts));
        this.$searchResults = this.$el.find('.search-results');
        this.$searchResults.sdaSelectList();
        this.$searchInput = this.$el.find('.search-input');
        this.$selectedGroup = this.$el.find('.selected-group');
        this.$ul = this.$searchResults.find('ul');
        this.hoverFlag = false;

        this.initSearch();
        this.bindEvents();
        if (this.opts.uuid && this.opts.text) {
            this.$el.val({uuid: this.opts.uuid, text: this.opts.text});
        }
    }

    initSearch() {
        this.searchObject.modifyCommonAndClause({
            property:
                this.opts.property ||
                this.searchObject.userModel.getTargetsWithPublishPermissions().map(target => target.site.name),
            type: this.opts.filtertypes,
            dateFrom: null,
            dateThru: new Moment()
                .utc()
                .add(1, 'day')
                .toISOString(),
        });
        this.searchObject.setSort('descendingDate');
        this.$el.data({collection: this.searchObject});
    }

    search = () => {
        const val = this.$searchInput.val();

        if (this.searchObject.fetchIsPending()) {
            this.searchObject.abortSearch();
        }
        if (!val) {
            this.$el.removeClass('searching');
            return;
        }
        this.$el.addClass('searching');
        this.lastQuantity = 0;
        this.$searchResults[0].clearList();
        this.searchObject.modifyCommonAndClause({
            textMatches: [val],
        });
        this.searchObject
            .getSearchResults()
            .then(this.addResults)
            .catch(error => {
                if (error.statusText !== 'abort') {
                    this.$el.removeClass('searching');
                }
            });
    };

    addResults = results => {
        const filteredResults = this.opts.filter ? results.filter(this.opts.filter) : results;
        _.each(filteredResults, result => {
            this.$searchResults.data().addItem(packageSearchResultTemplate(result));
        });

        this.lastResult = this.$searchResults
            .find('ul')
            .children()
            .last();
        this.lastQuantity += filteredResults.length;
        this.$searchResults.sdaSelectList();
        if (this.lastQuantity) {
            this.$el.trigger('showResults.sdaPackageSearch');
        }
        this.$el.removeClass('searching');
    };

    bindEvents() {
        this.$el
            .off('.sdaPackageSearch')
            .on('keyup.sdaPackageSearch', _.debounce(this.search, 200))
            .on('setVal.sdaPackageSearch', (e, val) => {
                if (!val.uuid || !val.text || this.$selectedGroup.is(':visible')) {
                    e.stopPropagation();
                    e.preventDefault();
                    return;
                }

                this.$selectedGroup
                    .show()
                    .find('.selected-item')
                    .val(val.text);
                this.$el.trigger('hideResults.sdaPackageSearch');
                this.$searchResults.close();
            })
            .hover(() => {
                this.hoverFlag = true;
            }, () => {
                this.hoverFlag = false;
            });
        if (this.opts.onChange) {
            this.$el.on('change.sdaPackageSearch', this.opts.onChange);
        }

        // search result is clicked
        this.$searchResults.off('change.val').on('change.val', (e, uuid) => {
            const $selected = this.$searchResults.find('.selected[data-selectable]');
            const val = {
                uuid,
                text: $selected.data('headline'),
            };

            e.stopPropagation();
            this.$el.val(val);
            this.$searchInput.focus().val('');
        });

        this.$searchInput
            .off('.sdaPackageSearch')
            .on('focus.sdaPackageSearch', () => {
                if (!this.$selectedGroup.is(':visible')) {
                    this.$searchResults.open();
                }
            })
            .on('focusout.sdaPackageSearch', () => {
                if (!this.hoverFlag) {
                    this.$searchResults.close();
                    this.$el.trigger('hideResults.sdaPackageSearch');
                    this.$searchInput.val('');
                }
            })
            .on('change.sdaPackageSearch', e => {
                e.stopPropagation();
            });

        this.$el
            .find('.remove-selected-package')
            .off('.sdaPackageSearch')
            .on('click.sdaPackageSearch', this.clearSelected);

        this.$ul.off('.sdaPackageSearch').on('scroll.sdaPackageSearch', _.debounce(this.onScroll, 100));
    }

    onScroll = () => {
        if (
            this.searchObject._availablePackages.length &&
            this.lastResult.offset().top - this.$ul.offset().top - 200 <= this.$ul.height()
        ) {
            this.searchObject.getMoreSummaries().then(this.addResults);
        }
    };

    clearSelected = () => {
        this.$selectedGroup.hide();
        this.$searchResults[0].clearList();
        this.$searchInput.focus().val('');
        this.$el.val({});
    };
}

$.fn.sdaPackageSearch = function(data) {
    return this.each(function() {
        new PackageSearch(this, {...data, ...$(this).data()});
    });
};
